import { create } from "zustand";
import axios from "../services/api/api";
import { AUTH_BASE_URL } from "../constants/api.constants";
import { jwtDecode } from "jwt-decode";
import queryClient from "../services/queryClient";
import useCartStore from "./useCartStore";
import useTeacherNavStore from "./useTeacherNavStore";

const getInitialAuthFromToken = () => {
  const token = localStorage.getItem("token");
  if (!token) return { authenticated: false, roles: null, email: null };
  try {
    const decoded = jwtDecode(token);
    return {
      authenticated: true,
      roles: Object.values(decoded)[3],
      email: localStorage.getItem("email"),
    };
  } catch {
    return { authenticated: false, roles: null, email: null };
  }
};

const initialAuth = getInitialAuthFromToken();

const useAuthStore = create((set) => ({
  token: null,
  refresh_token: null,
  code: null,
  message: null,
  exp: null,
  email: initialAuth.email,
  roles: initialAuth.roles,
  error: null,
  isLoggingIn: false,
  authenticated: initialAuth.authenticated,
  switchedUser: false,

  signIn: async (email, password) => {
    set({ isLoggingIn: true, error: null });
    try {
      const res = await axios.post(`${AUTH_BASE_URL}/token/auth`, {
        email,
        password,
        grant_type: "password",
      });

      if (res.data.result.code === "999") {
        const tokenData = JSON.parse(res.data.result.data);
        const decodedToken = jwtDecode(tokenData.access_token);
        const roles = Object.values(decodedToken)[3];

        axios.defaults.headers.common["Authorization"] = tokenData.access_token;
        localStorage.setItem("token", tokenData.access_token);
        localStorage.setItem("refresh_token", tokenData.refresh_token);
        localStorage.setItem("email", res.data.result.email);
        localStorage.setItem("role", roles);

        set({
          authenticated: true,
          isLoggingIn: false,
          token: tokenData.access_token,
          refresh_token: tokenData.refresh_token,
          code: res.data.result.code,
          message: res.data.result.message,
          exp: decodedToken.exp,
          email: res.data.result.email,
          roles,
          error: null,
        });
      } else {
        set({ error: "signin.unauthorized", isLoggingIn: false });
      }
    } catch (err) {
      set({
        error: "signin.unauthorized",
        isLoggingIn: false,
        message: err.message,
      });
    }
  },

  signOut: () => {
    axios.defaults.headers.common["Authorization"] = null;
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    localStorage.removeItem("schoolName");
    localStorage.removeItem("school");
    localStorage.removeItem("aplSupervisorHasRegistered");
    localStorage.removeItem("help");
    localStorage.removeItem("showResult");
    useCartStore.getState().clearCart();
    useTeacherNavStore.getState().reset();
    queryClient.clear();
    set({
      authenticated: false,
      token: null,
      refresh_token: null,
      code: null,
      message: null,
      exp: null,
      email: null,
      roles: null,
      error: null,
      isLoggingIn: false,
    });
  },

}));

// Other tabs only: a login there as someone else replaces this tab's user.
window.addEventListener("storage", (event) => {
  const ownEmail = useAuthStore.getState().email;
  if (
    event.key === "email" &&
    ownEmail &&
    event.newValue &&
    event.newValue.toLowerCase() !== ownEmail.toLowerCase()
  ) {
    useAuthStore.setState({ switchedUser: true });
  }
});

export default useAuthStore;
